export class DownloadLogFilterCriteria {
  documentNameOrTitle: string;
  companyName: string;
  fullNameOrEmail: string;
  dateFrom: Date;
  dateTo: Date;

  constructor(documentNameOrTitle, companyName, fullNameOrEmail, dateFrom, dateTo) {
    this.documentNameOrTitle = documentNameOrTitle;
    this.companyName = companyName;
    this.fullNameOrEmail = fullNameOrEmail;
    this.dateFrom = dateFrom;
    this.dateTo = dateTo;
  }

}
